import React, { useRef, useState, useEffect } from "react";
import styles from "./RoundInfoItem.module.scss";
import Lock from "../../public/assets/img/lock.png";

const RoundInfoItem = ({ infoImage, info, moreInfos, more, less, contactsLabel, contacts, loyalty, tier, locked_phrase }) => {
  const [discovermore, setDiscoverMore] = useState(false);
  const [accordionButton, setAccordionButton] = useState(more);

  const ref = useRef(null);

  const handleClick = () => {
    setDiscoverMore(!discovermore);
    if (discovermore == true) {
      setAccordionButton(more);
    } else {
      setAccordionButton(less);
    }
  };

  const available = () => {
    if(!tier || loyalty == null) return true;
    return loyalty.findIndex( el => el == tier ) != -1;
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setDiscoverMore(false);
        setAccordionButton(more);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div className={styles.roundInfoItem} ref={ref}>
      <img
        onClick={handleClick}
        src={infoImage.src}
        alt={infoImage.alt}
        className={discovermore ? styles.imgCollapsed : null}
      ></img>
      {tier && !available() && <div className={styles.roundInfoLocked}>
        <img src={Lock.src} />
        <span>{locked_phrase}</span>
      </div>}
      <div className={styles.info}>{info}</div>


      {available() && <><div
        className={styles.accordion}
        onClick={handleClick}
        style={{
          display: moreInfos && accordionButton == more ? null : "none",
        }}
      >
        {accordionButton}
        <button className={styles.accordionButton}>
          <div className={discovermore ? styles.hideLineFirst : null}></div>
          <div className={discovermore ? styles.hideLine : null}></div>
        </button>
      </div>
      <div
        className={`${styles.moreInfos} ${
          discovermore ? styles.moreInfosOpen : null
        }`}
      >
        <div
          dangerouslySetInnerHTML={{ __html: moreInfos }}
          style={{ display: moreInfos ? null : "none" }}
        ></div>
        {contacts && contacts.length && <div className={styles.bookingContacts}>
            {contactsLabel && <div className={styles.title}>{contactsLabel}</div>}
            <div className={styles.list}>
            {contacts.map( (c, ind) => <a key={ind} href={c.url}>{c.label}</a>)}
            </div>
          </div>}
        <div
          className={styles.accordion}
          onClick={handleClick}
          style={{
            display: moreInfos && accordionButton == less ? null : "none",
          }}
        >
          {accordionButton}
          <button className={styles.accordionButton}>
            <div className={discovermore ? styles.hideLineFirst : null}></div>
            <div className={discovermore ? styles.hideLine : null}></div>
          </button>
        </div>
      </div>
      </>}



    </div>
  );
};

export default RoundInfoItem;
